import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useLocation } from 'react-router';

import { useI18n } from '../../../../../../application/language/useI18n';
import { DataTable } from '../../../../../design/dataTable/DataTable';
import { IAdminPageProperties } from '../../../IAdminPageProperties';
import { ApplicationInfoWarning } from '../components/ApplicationInfoWarning';
import { UserProjectRoleAdminDomain } from './store/UserProjectRoleAdminDomain';

export interface UserProjectRoleAdminTableProperties extends IAdminPageProperties {}

export const UserProjectRoleAdminTable = observer(({ layoutDomain }: UserProjectRoleAdminTableProperties) => {
  const { translate } = useI18n();
  const [domain] = useState(new UserProjectRoleAdminDomain(layoutDomain));
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const unitsUpdating = searchParams.get('unitsUpdating');

  return (
    <>
      {unitsUpdating && (
        <Box my={2}>
          <ApplicationInfoWarning
            warningText={translate('projectRoles.rolesUpdatedTitle')}
            description={translate('projectRoles.rolesUpdatedMessage')}
          />
        </Box>
      )}
      <DataTable dataTableDomain={domain} />
    </>
  );
});
